module.exports = __webpack_public_path__ + "static/media/bt.dbb1623f.svg";